/**
 * Session guard utility.
 * Clears the client session from localStorage and dispatches
 * the cross-instance sync event when the server rejects a token (401).
 */

const SESSION_KEY = "rpgcoin_client_session";
const SESSION_CHANGE_EVENT = "rpgcoin_session_change";

/**
 * Call this after any Edge Function invocation that returns a 401
 * or an `error: "Token inválido"` response. It will force-logout
 * the user across all hook instances in the current tab.
 */
export const handleInvalidSession = () => {
  localStorage.removeItem(SESSION_KEY);
  setTimeout(() => window.dispatchEvent(new Event(SESSION_CHANGE_EVENT)), 0);
};

/**
 * Wraps a supabase.functions.invoke call and auto-clears the session
 * when the server responds with 401 or "Token inválido".
 */
export const invokeWithSessionGuard = async (
  invoke: () => Promise<{ data: any; error: any }>
): Promise<{ data: any; error: any }> => {
  const result = await invoke();

  // Edge functions return 401 as an error with status in the message
  if (result.error) {
    const msg = String(result.error?.message || result.error || "");
    if (msg.includes("401") || msg.includes("Token inválido") || msg.includes("Sessão inválida")) {
      handleInvalidSession();
    }
  }

  // Some functions return { error: "Token inválido" } with status 200
  if (result.data?.error === "Token inválido" || result.data?.error === "Sessão inválida") {
    handleInvalidSession();
  }

  return result;
};
